import { Navigate, Route, Routes } from "react-router-dom";
import OverviewPage from "../pages/overview";
import AlertsPage from "../pages/alerts";
import LogsPage from "../pages/logs";
import CronJobsPage from "../pages/cron-jobs";
import HealthPage from "../pages/health";
import StatusWallPage from "../pages/status-wall";
import Users from "../pages/users";
import Auth from "../pages/Auth";
import Reset from "../pages/Reset";

function MainComponent() {
  return (
    <Routes>
      <Route path="/auth" element={<Auth />} />
      <Route path="/reset" element={<Reset />} />
      <Route path="/" element={<OverviewPage />} />
      <Route path="/alerts" element={<AlertsPage />} />
      <Route path="/logs" element={<LogsPage />} />
      <Route path="/cron-jobs" element={<CronJobsPage />} />
      <Route path="/health" element={<HealthPage />} />
      <Route path="/wall" element={<StatusWallPage />} />
      <Route path="/users" element={<Users />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default MainComponent;
